(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-collection"] && !Shopify.designMode) return;
  try {
    
  // --- Shared scroll reveal ---------------------------------------------
  // Needed here even though this file contains no .cf-reveal markup: the
  // product cards come from the cf-product-card snippet, so the class shows up
  // in the rendered DOM. Without this the whole grid renders at opacity 0.
  (function () {
    if (window.cfRevealInit) return;
    window.cfRevealInit = true;
    document.documentElement.classList.add('cf-reveal-ready');

    function observe(scope) {
      var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('cf-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cf-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    window.cfRevealRescan = function (scope) { observe(scope); };
    document.addEventListener('DOMContentLoaded', function () { observe(); });
    if (document.readyState !== 'loading') observe();
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  })();

(function () {
  document.documentElement.setAttribute('data-cf-js', '');

  function init(root) {
    if (!root || root.dataset.cfColInit === '1') return;
    root.dataset.cfColInit = '1';

    var grid = root.querySelector('[data-cf-grid]');

    // --- Fetch a filtered/sorted URL and swap the grid + sidebar in ---------
    function navigate(url, opts) {
      opts = opts || {};
      if (grid) grid.style.opacity = '0.4';
      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-cf-collection]');
          if (!next) { window.location.href = url; return; }

          ['[data-cf-grid]', '[data-cf-sidebar]', '[data-cf-count]', '[data-cf-pages]', '[data-cf-progress]', '.cf-col__more'].forEach(function (q) {
            var oldEl = root.querySelector(q);
            var newEl = next.querySelector(q);
            if (oldEl && newEl) oldEl.replaceWith(newEl);
            else if (oldEl && !newEl) oldEl.remove();
          });

          history.pushState({}, '', url);
          rebind();
          if (opts.scroll !== false) {
            root.querySelector('.cf-col__toolbar').scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          window.cfRevealRescan && window.cfRevealRescan(root);
        })
        .catch(function () { window.location.href = url; });
    }

    // --- Filters auto-apply on change --------------------------------------
    function serialize() {
      var f = root.querySelector('[data-cf-filter-form]');
      if (!f) return root.querySelector('[data-cf-grid]') ? location.pathname : location.href;
      var params = new URLSearchParams(new FormData(f));
      // Drop empty price fields so they don't add ?filter=&... noise.
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      return location.pathname + (clean.toString() ? '?' + clean.toString() : '');
    }

    function rebind() {
      var nojs = root.querySelectorAll('[data-cf-nojs-actions]');
      nojs.forEach(function (el) { el.style.display = 'none'; });

      root.querySelectorAll('[data-cf-filter-input]').forEach(function (input) {
        input.addEventListener('change', function () { navigate(serialize(), { scroll: false }); });
      });

      var s = root.querySelector('[data-cf-sort]');
      if (s) s.addEventListener('change', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', s.value);
        navigate(u.pathname + u.search, { scroll: false });
      });

      bindMore();
      bindDrawer();
    }

    // --- Load more appends, keeping filters/sort in the URL ----------------
    function bindMore() {
      var btn = root.querySelector('[data-cf-load-more]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.classList.add('is-loading');
        fetch(btn.dataset.nextUrl, { headers: { 'X-Requested-With': 'fetch' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newCards = doc.querySelectorAll('[data-cf-grid] > *');
            var g = root.querySelector('[data-cf-grid]');
            newCards.forEach(function (c) { g.appendChild(c); });

            var more = root.querySelector('.cf-col__more');
            var newMore = doc.querySelector('.cf-col__more');
            if (newMore) more.replaceWith(newMore); else more.remove();
            rebind();
            window.cfRevealRescan && window.cfRevealRescan(root);
          })
          .catch(function () { window.location.href = btn.dataset.nextUrl; });
      });
    }

    // --- Mobile drawer ------------------------------------------------------
    function bindDrawer() {
      var open = root.querySelector('[data-cf-filter-open]');
      var sidebar = root.querySelector('[data-cf-sidebar]');
      if (!open || !sidebar) return;
      function show() { root.classList.add('is-filtering'); sidebar.classList.add('is-open'); open.setAttribute('aria-expanded', 'true'); }
      function hide() { root.classList.remove('is-filtering'); sidebar.classList.remove('is-open'); open.setAttribute('aria-expanded', 'false'); }
      open.addEventListener('click', show);
      root.querySelectorAll('[data-cf-filter-close]').forEach(function (el) { el.addEventListener('click', hide); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    }

    window.addEventListener('popstate', function () { navigate(location.pathname + location.search, { scroll: false }); });
    rebind();
  }

  function boot() { document.querySelectorAll('[data-cf-collection]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-cf-collection]');
    if (el) { el.dataset.cfColInit = ''; init(el); }
  });
})();

  // --- Quick Add -----------------------------------------------------------
  // Cards here come from the same cf-product-card snippet used on the
  // homepage grid, but that snippet ships no JS of its own — the click
  // handler lived only in cf-product-grid.liquid's own {% javascript %}
  // block, which never loads on a collection page. Result: the button
  // existed and looked interactive, but nothing was listening, so it never
  // actually added anything to the cart. Same handler as cf-product-grid,
  // guarded so it's a no-op if that section happens to load on the same
  // page too.
  (function () {
    if (window.cfQuickAddInit) return;
    window.cfQuickAddInit = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cf-quick-add]');
      if (!btn || btn.disabled) return;

      // The card is wrapped in a stretched link. Without this, Quick Add
      // navigates to the product page instead of adding to the cart.
      e.preventDefault();
      e.stopPropagation();

      var label = btn.querySelector('[data-cf-add-label]');
      var original = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add');
          if (label) label.textContent = 'Added ✓';
          // Tell the header badge. Both channels — themes disagree on the name.
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: res.body }));
          if (window.cfRefreshCart) window.cfRefreshCart();
          try {
            var cartDrawerEl = document.querySelector('cart-drawer');
            if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
              cartDrawerEl.renderContents(res.body);
            }
          } catch (drawerErr) {}
          setTimeout(function () {
            if (label) label.textContent = original;
            btn.disabled = false;
          }, 1600);
        })
        .catch(function (err) {
          // Surface the real reason — "sold out" and "network died" are not the
          // same problem, and a silent failure teaches the customer nothing.
          if (label) label.textContent = 'Unavailable';
          console.error('[cf] quick add:', err);
          setTimeout(function () {
            if (label) label.textContent = original;
            btn.disabled = false;
          }, 2200);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-comparison-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.cfRevealInit) return;
    window.cfRevealInit = true;
    document.documentElement.classList.add('cf-reveal-ready');
    function observe(scope) {
      var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('cf-in'); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('cf-in'); io.unobserve(entry.target); } });
      }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    window.cfRevealRescan = function (scope) { observe(scope); };
    document.addEventListener('DOMContentLoaded', function () { observe(); });
    if (document.readyState !== 'loading') observe();
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.cfRevealInit) return;
    window.cfRevealInit = true;
    document.documentElement.classList.add('cf-reveal-ready');
    function observe(scope) {
      var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('cf-in'); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('cf-in'); io.unobserve(entry.target); } });
      }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }
    window.cfRevealRescan = function (scope) { observe(scope); };
    document.addEventListener('DOMContentLoaded', function () { observe(); });
    if (document.readyState !== 'loading') observe();
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-contact-cta"] && !Shopify.designMode) return;
  try {
    
  // --- Shared scroll reveal ---------------------------------------------
  // Every section that emits .cf-reveal carries this. Guarded so it runs once
  // per page however many sections include it.
  (function () {
    if (window.cfRevealInit) return;
    window.cfRevealInit = true;
    document.documentElement.classList.add('cf-reveal-ready');

    function observe(scope) {
      var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('cf-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cf-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    window.cfRevealRescan = function (scope) { observe(scope); };
    document.addEventListener('DOMContentLoaded', function () { observe(); });
    if (document.readyState !== 'loading') observe();
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-corporate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.cfRevealInit) return;
    window.cfRevealInit = true;
    document.documentElement.classList.add('cf-reveal-ready');
    function observe(scope) {
      var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { els.forEach(function (el){ el.classList.add('cf-in'); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e){ if (e.isIntersecting){ e.target.classList.add('cf-in'); io.unobserve(e.target); } });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (el){ io.observe(el); });
    }
    window.cfRevealRescan = function (s){ observe(s); };
    document.addEventListener('DOMContentLoaded', function(){ observe(); });
    if (document.readyState !== 'loading') observe();
    document.addEventListener('shopify:section:load', function(e){ observe(e.target); });
  })();

  // --- Testimonial carousel ---
  (function () {
    document.querySelectorAll('[data-cf-tst]').forEach(function (root) {
      var track = root.querySelector('[data-cf-tst-track]');
      var slides = root.querySelectorAll('[data-cf-tst-slide]');
      var dots = root.querySelectorAll('[data-cf-tst-dot]');
      var prev = root.querySelector('[data-cf-tst-prev]');
      var next = root.querySelector('[data-cf-tst-next]');
      if (!track || slides.length < 2) return;
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }
      if (prev) prev.addEventListener('click', function(){ go(i - 1); });
      if (next) next.addEventListener('click', function(){ go(i + 1); });
      dots.forEach(function (d, di) { d.addEventListener('click', function(){ go(di); }); });
      var timer = setInterval(function(){ go(i + 1); }, 7000);
      root.addEventListener('mouseenter', function(){ clearInterval(timer); });
    });
  })();

  // --- "Build my gifting programme" quote popup ---
  (function () {
    var popup = document.querySelector('[data-cfco-quote-popup]');
    if (!popup) return;
    var openBtns = document.querySelectorAll('[data-cfco-open-quote]');
    var closeBtn = popup.querySelector('[data-cfco-close-quote]');

    popup.querySelectorAll('form[data-cf-ajax-form]').forEach(function (cfForm) {
      if (cfForm.dataset.cfBound) return;
      cfForm.dataset.cfBound = 'true';
      cfForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var successEl = cfForm.querySelector('[data-cf-success]');
        var hideEls = cfForm.querySelectorAll('[data-cf-hide-on-success]');
        var submitBtn = cfForm.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        var formData = new FormData(cfForm);
        var emailInput = cfForm.querySelector('input[type="email"]');
        if (emailInput && emailInput.value) formData.append('_replyto', emailInput.value);
        fetch(cfForm.action, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function (response) {
            if (response.ok) {
              hideEls.forEach(function (el) { el.hidden = true; });
              if (successEl) successEl.hidden = false;
              cfForm.reset();
            }
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    });

    function openPopup() {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var firstInput = popup.querySelector('input');
        if (firstInput) firstInput.focus();
      }, 250);
    }
    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    openBtns.forEach(function (btn) { btn.addEventListener('click', openPopup); });
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    popup.addEventListener('click', function (event) { if (event.target === popup) closePopup(); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-faq"] && !Shopify.designMode) return;
  try {
    
  // --- Shared scroll reveal ---------------------------------------------
  // Every section that emits .cf-reveal carries this. Guarded so it runs once
  // per page however many sections include it.
  (function () {
    if (window.cfRevealInit) return;
    window.cfRevealInit = true;
    document.documentElement.classList.add('cf-reveal-ready');

    function observe(scope) {
      var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('cf-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cf-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    window.cfRevealRescan = function (scope) { observe(scope); };
    document.addEventListener('DOMContentLoaded', function () { observe(); });
    if (document.readyState !== 'loading') observe();
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeader(root) {
    if (!root || root.dataset.cfInit === '1') return;
    root.dataset.cfInit = '1';

    var isOverlay = root.dataset.overlay === 'true';

    // --- Publish height for other templates -------------------------------
    // A floating header sits OUTSIDE normal flow, so page content starts at
    // y=0 and hides underneath it. The hero wants that; a collection page does
    // not. Measure ourselves and expose --cf-header-offset so any section that
    // needs to clear the bar can, without hard-coding a height that goes stale
    // the moment someone drags the height slider.
    function publishHeight() {
      if (!isOverlay) {
        document.documentElement.style.removeProperty('--cf-header-offset');
        return;
      }
      var bar = root.querySelector('.cf-header__bar');
      document.documentElement.style.setProperty(
        '--cf-header-offset', (bar ? bar.offsetHeight : 68) + 'px'
      );
    }
    publishHeight();
    window.addEventListener('resize', publishHeight, { passive: true });

    // --- Solid state on scroll -------------------------------------------
    // Glass-from-top means the solid state is permanent — nothing to toggle.
    if (isOverlay && root.dataset.glassTop !== 'true') {
      var ticking = false;
      function check() {
        root.classList.toggle('is-solid', window.scrollY > 40);
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(check); }
      }, { passive: true });
      check();
    }

    // --- Mega panels ------------------------------------------------------
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cf-nav-item]'));
    var openItem = null;
    var closeTimer = null;

    function closePanel(item) {
      if (!item) return;
      var btn = item.querySelector('[data-cf-nav-toggle]');
      var panel = item.querySelector('[data-cf-nav-panel]');
      if (!btn || !panel) return;
      btn.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-open');
      // Wait for the fade before removing from the a11y tree.
      setTimeout(function () {
        if (btn.getAttribute('aria-expanded') === 'false') panel.hidden = true;
      }, 280);
      if (openItem === item) {
        openItem = null;
        root.classList.remove('has-panel-open');
      }
    }

    function openPanel(item) {
      var btn = item.querySelector('[data-cf-nav-toggle]');
      var panel = item.querySelector('[data-cf-nav-panel]');
      if (!btn || !panel) return;
      if (openItem && openItem !== item) closePanel(openItem);
      panel.hidden = false;
      // Next frame, so the transition has a start value to animate from.
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      btn.setAttribute('aria-expanded', 'true');
      openItem = item;
      root.classList.add('has-panel-open');
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-cf-nav-toggle]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        btn.getAttribute('aria-expanded') === 'true' ? closePanel(item) : openPanel(item);
      });

      // Hover only where hovering is meaningful — not on touch.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        item.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          openPanel(item);
        });
        item.addEventListener('mouseleave', function () {
          // Grace period so a diagonal mouse path to the panel doesn't close it.
          closeTimer = setTimeout(function () { closePanel(item); }, 180);
        });
      }

      // Focus leaving the item entirely closes it — keyboard parity with hover.
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closePanel(item);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        var btn = openItem.querySelector('[data-cf-nav-toggle]');
        closePanel(openItem);
        if (btn) btn.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) closePanel(openItem);
    });

    // --- Mobile drawer ----------------------------------------------------
    var burger = root.querySelector('[data-cf-burger]');
    var drawer = document.getElementById(burger && burger.getAttribute('aria-controls'));
    if (burger && drawer) {
      var lastFocus = null;

      function openDrawer() {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        burger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var first = drawer.querySelector('a, button');
        if (first) first.focus();
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () {
          if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        }, 450);
        if (lastFocus) lastFocus.focus();
      }

      burger.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-cf-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
        if (e.key !== 'Tab') return;
        // Focus trap: a modal that lets you tab out into the page behind it
        // is a screen-reader trap of the worse kind.
        var f = drawer.querySelectorAll('a[href], button:not([disabled]), summary');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    // --- Live cart count --------------------------------------------------
    var badge = root.querySelector('[data-cf-cart-count]');
    var cartLink = root.querySelector('[data-cf-cart]');

    function refreshCart() {
      if (!badge) return;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          badge.textContent = c.item_count;
          badge.classList.toggle('is-empty', c.item_count === 0);
          if (cartLink) cartLink.setAttribute('aria-label', 'Cart (' + c.item_count + ' items)');
        })
        .catch(function () {});
    }

    // Themes and apps don't agree on a cart event name, so listen broadly.
    ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart:afterCartLoad'].forEach(function (evt) {
      document.addEventListener(evt, refreshCart);
    });
    if (window.PUB_SUB_EVENTS && window.subscribe) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCart); } catch (e) {}
    }
    window.cfRefreshCart = refreshCart;
  }

  function initAll() { document.querySelectorAll('[data-cf-header]').forEach(initHeader); }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-cf-header]');
    if (el) initHeader(el);
  });
})();

  // --- Wishlist icon: only show once there's something to show -----------
  // Both wishlist links (desktop icon, mobile drawer row) start hidden in
  // the markup, so an empty wishlist never appears in the header. Wishlist
  // Hero (the installed app) keeps the saved list in localStorage under
  // 'wishlisthero_.wl-itms' and fires 'wishlist-hero-wishlist-updated'
  // whenever it changes (add, remove, "remove all"). We read that directly
  // rather than waiting on the app's own header-icon feature, since nothing
  // here depends on Wishlist Hero rendering an icon of its own — it only
  // needs to answer "is the list empty right now?".
  (function () {
    if (window.cfWishlistVisInit) return;
    window.cfWishlistVisInit = true;

    function wishlistCount() {
      try {
        var raw = localStorage.getItem('wishlisthero_.wl-itms');
        if (!raw) return 0;
        var items = JSON.parse(raw);
        return Array.isArray(items) ? items.length : 0;
      } catch (e) {
        return 0;
      }
    }

    function refresh() {
      var count = wishlistCount();
      document.querySelectorAll('[data-cf-wishlist-link]').forEach(function (link) {
        link.hidden = count === 0;
        var badge = link.querySelector('[data-cf-wishlist-count]');
        if (badge) {
          badge.hidden = count === 0;
          badge.textContent = count;
        }
      });
    }

    refresh();
    // The app's own events — fire on every add/remove, including from the
    // popup's "Remove all favorite" link.
    ['wishlist-hero-wishlist-updated', 'wishlist-hero-links-binded'].forEach(function (evt) {
      document.addEventListener(evt, refresh);
    });
    // Wishlist Hero finishes loading asynchronously; catch the case where
    // it updates localStorage slightly after our first read above.
    setTimeout(refresh, 1200);
    // Cross-tab: the app doesn't dispatch its own event for changes made in
    // another tab, but the browser's storage event does.
    window.addEventListener('storage', function (e) {
      if (e.key === 'wishlisthero_.wl-itms') refresh();
    });
    document.addEventListener('shopify:section:load', refresh);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHero(root) {
    if (!root || root.dataset.cfInit === '1') return;
    root.dataset.cfInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cf-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cf-dot]'));
    var media = root.querySelector('[data-cf-media]');
    var index = 0;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }

    function start() {
      var ms = parseInt(root.dataset.autoplay, 10);
      if (!ms || slides.length < 2 || REDUCED.matches) return;
      stop();
      timer = setInterval(function () { show(index + 1); }, ms);
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.dataset.index, 10));
        start(); // reset the clock so the slide the user picked gets a full turn
      });
    });

    // Don't burn CPU animating a hero nobody is looking at.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? start() : stop();
      }, { threshold: 0.05 }).observe(root);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });

    // --- Parallax + overlay, replacing framer-motion useScroll -------------
    if (root.dataset.parallax !== 'true' || REDUCED.matches || !media) return;

    var ticking = false;
    function frame() {
      var h = root.offsetHeight || 1;
      // 0 at top of hero, 1 once the hero has fully scrolled past.
      var p = Math.min(1, Math.max(0, -root.getBoundingClientRect().top / h));
      media.style.transform = 'translate3d(0,' + p * 18 + '%,0) scale(' + (1 + p * 0.12) + ')';
      root.style.setProperty('--p', p.toFixed(3));
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  }

  function initAll() {
    document.querySelectorAll('[data-cf-hero]').forEach(initHero);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-cf-hero]');
    if (el) initHero(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-plant-care-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var finder = document.querySelector('[data-cf-finder]');
    if (!finder || finder.dataset.finderReady) return;
    finder.dataset.finderReady = 'true';
    var steps = finder.querySelectorAll('[data-cf-step]');
    var answers = {};
    var progress = finder.querySelector('[data-cf-progress]');
    var results = finder.querySelector('[data-cf-results]');
    var list = finder.querySelector('[data-cf-result-list]');
    var source = finder.querySelector('[data-cf-finder-products]');
    var products = source ? JSON.parse(source.textContent) : {};

    function showStep(number) {
      steps.forEach(function (step) { var active = Number(step.dataset.cfStep) === number; step.hidden = !active; step.classList.toggle('is-active', active); });
      progress.style.width = (number / 3 * 100) + '%';
    }
    function resultSubtitle() {
      if (answers.goal === 'bloom') return 'A flowering-focused edit for more colour and happier buds.';
      if (answers.goal === 'growth') return 'A growth-focused edit for lusher leaves and stronger roots.';
      if (answers.goal === 'style') return 'A finishing edit to make your plant corner feel complete.';
      return 'A gentle reset edit to help your plant get back on track.';
    }
    function renderResults() {
      steps.forEach(function (step) { step.hidden = true; });
      progress.style.width = '100%';
      results.hidden = false;
      finder.querySelector('[data-cf-result-subtitle]').textContent = resultSubtitle();
      var picks = (products[answers.goal] || []).filter(Boolean);
      if (!picks.length) {
        list.innerHTML = '<div class="cf-finder__empty">Your edit is ready. Add up to three products for this goal in the Plant Care Finder section settings to show tailored recommendations here.</div>';
        return;
      }
      list.innerHTML = picks.map(function (item) {
        var image = item.image ? '<img src="' + item.image + '" alt="">' : '<span class="cf-finder__product-placeholder"></span>';
        var action = item.available ? '<button type="button" class="cf-finder__add" data-cf-add="' + item.id + '" aria-label="Add ' + item.title.replace(/"/g, '&quot;') + ' to cart">+</button>' : '<button class="cf-finder__add" disabled aria-label="Sold out">+</button>';
        return '<div class="cf-finder__product">' + image + '<div class="cf-finder__product-info"><a href="' + item.url + '">' + item.title + '</a><p>' + item.price + '</p></div>' + action + '</div>';
      }).join('');
    }
    finder.querySelectorAll('[data-cf-answer]').forEach(function (button) {
      button.addEventListener('click', function () {
        var key = button.dataset.key;
        answers[key] = button.dataset.value;
        button.closest('[data-cf-step]').querySelectorAll('[data-cf-answer]').forEach(function (item) { item.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        window.setTimeout(function () { key === 'experience' ? renderResults() : showStep(key === 'light' ? 2 : 3); }, 220);
      });
    });
    finder.querySelector('[data-cf-restart]').addEventListener('click', function () { answers = {}; results.hidden = true; finder.querySelectorAll('[data-cf-answer]').forEach(function (button) { button.classList.remove('is-selected'); }); showStep(1); });
    list.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cf-add]'); if (!button) return;
      button.disabled = true; button.textContent = '✓';
      fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({id: Number(button.dataset.cfAdd), quantity: 1}) })
        .then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); button.textContent = '✓'; })
        .catch(function () { button.disabled = false; button.textContent = '+'; });
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-product-grid"] && !Shopify.designMode) return;
  try {
    
  // --- Shared scroll reveal ---------------------------------------------
  // Duplicated verbatim across sections on purpose: each page must be able to
  // reveal its own content without depending on some other section being
  // present. The window guard means it initialises exactly once per page no
  // matter how many sections carry it.
  (function () {
    if (window.cfRevealInit) return;
    window.cfRevealInit = true;

    // Opt in to the hidden-then-revealed styling only now that we can
    // guarantee something will reveal it.
    document.documentElement.classList.add('cf-reveal-ready');

    function observe(scope) {
      var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('cf-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cf-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    window.cfRevealRescan = function (scope) { observe(scope); };
    document.addEventListener('DOMContentLoaded', function () { observe(); });
    if (document.readyState !== 'loading') observe();
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  })();

(function () {
  if (window.cfQuickAddInit) return;
  window.cfQuickAddInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cf-quick-add]');
    if (!btn || btn.disabled) return;

    // The card is wrapped in a stretched link. Without this, Quick Add
    // navigates to the product page instead of adding to the cart.
    e.preventDefault();
    e.stopPropagation();

    var label = btn.querySelector('[data-cf-add-label]');
    var original = label ? label.textContent : '';
    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add');
        if (label) label.textContent = 'Added ✓';
        // Tell the header badge. Both channels — themes disagree on the name.
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: res.body }));
        if (window.cfRefreshCart) window.cfRefreshCart();
        try {
          var cartDrawerEl = document.querySelector('cart-drawer');
          if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
            cartDrawerEl.renderContents(res.body);
          }
        } catch (drawerErr) {}
        setTimeout(function () {
          if (label) label.textContent = original;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function (err) {
        // Surface the real reason — "sold out" and "network died" are not the
        // same problem, and a silent failure teaches the customer nothing.
        if (label) label.textContent = 'Unavailable';
        console.error('[cf] quick add:', err);
        setTimeout(function () {
          if (label) label.textContent = original;
          btn.disabled = false;
        }, 2200);
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-product"] && !Shopify.designMode) return;
  try {
    
  // --- Shared scroll reveal ---------------------------------------------
  // Needed here even though this file contains no .cf-reveal markup: the
  // product cards come from the cf-product-card snippet, so the class shows up
  // in the rendered DOM. Without this the whole grid renders at opacity 0.
  (function () {
    if (window.cfRevealInit) return;
    window.cfRevealInit = true;
    document.documentElement.classList.add('cf-reveal-ready');

    function observe(scope) {
      var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('cf-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cf-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    window.cfRevealRescan = function (scope) { observe(scope); };
    document.addEventListener('DOMContentLoaded', function () { observe(); });
    if (document.readyState !== 'loading') observe();
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  })();

(function () {
  function init(root) {
    if (!root || root.dataset.cfPdInit === '1') return;
    root.dataset.cfPdInit = '1';

    var variantsEl = root.querySelector('[data-cf-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}

    var idField = root.querySelector('[data-cf-variant-id]');
    var priceEl = root.querySelector('[data-cf-price]');
    var compareEl = root.querySelector('[data-cf-compare]');
    var addBtn = root.querySelector('[data-cf-add]');
    var addText = root.querySelector('[data-cf-add-text]');
    var addLabel = (addBtn && addBtn.dataset.addLabel) || 'Add to cart';
    var slides = root.querySelectorAll('[data-cf-slide]');
    var thumbs = root.querySelectorAll('[data-cf-thumb]');
    var stage = root.querySelector('.cf-pd__stage');

    // --- Gallery ----------------------------------------------------------
    function showMedia(id) {
      slides.forEach(function (s) {
        var isActive = s.dataset.mediaId === String(id);
        s.classList.toggle('is-active', isActive);
        if (isActive && stage && s.dataset.cfMediaRatio) {
          stage.style.setProperty('--cf-pd-media-ratio', s.dataset.cfMediaRatio);
        }
      });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === String(id)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaId); }); });

    // --- Variant selection ------------------------------------------------
    function selectedOptions() {
      var inputs = root.querySelectorAll('[data-cf-option-input]:checked');
      var opts = [];
      inputs.forEach(function (i) { opts[i.dataset.optionPosition - 1] = i.value; });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, idx) { return o === opts[idx]; });
      });
    }

    // Grey out option values that can't be combined with the current picks.
    function markAvailability() {
      var groups = root.querySelectorAll('[data-cf-option-index]');
      groups.forEach(function (group) {
        var pos = parseInt(group.dataset.cfOptionIndex, 10);
        group.querySelectorAll('[data-cf-option-input]').forEach(function (input) {
          var trial = selectedOptions();
          trial[pos] = input.value;
          var v = variants.find(function (vv) {
            return vv.options.every(function (o, idx) {
              return trial[idx] == null || o === trial[idx];
            });
          });
          var swatch = input.closest('.cf-pd__swatch');
          if (swatch) swatch.classList.toggle('is-unavailable', !(v && v.available));
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = matchVariant(opts);

      // Reflect the chosen value label in each option head.
      root.querySelectorAll('[data-cf-option-input]:checked').forEach(function (i) {
        var head = root.querySelector('[data-cf-option-selected="' + (i.dataset.optionPosition - 1) + '"]');
        if (head) head.textContent = i.value;
      });

      markAvailability();

      if (!v) {
        addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }

      if (idField) idField.value = v.id;
      if (priceEl) {
        priceEl.textContent = v.price_formatted;
        priceEl.classList.toggle('is-sale', v.compare_at > v.price);
      }
      if (compareEl) {
        if (v.compare_at > v.price) { compareEl.textContent = v.compare_formatted; compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (v.featured_media_id) showMedia(v.featured_media_id);

      addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? addLabel : 'Sold out';

      // Keep the URL's ?variant= in step, so a refresh or share lands right.
      if (history.replaceState && v.id) {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    root.querySelectorAll('[data-cf-option-input]').forEach(function (i) {
      i.addEventListener('change', update);
    });

    // --- Quantity ---------------------------------------------------------
    var qty = root.querySelector('[data-cf-qty]');
    root.querySelector('[data-cf-qty-down]') && root.querySelector('[data-cf-qty-down]').addEventListener('click', function () {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
    });
    root.querySelector('[data-cf-qty-up]') && root.querySelector('[data-cf-qty-up]').addEventListener('click', function () {
      qty.value = (parseInt(qty.value, 10) || 1) + 1;
    });

    // --- Add to cart (AJAX) ----------------------------------------------
    var form = root.querySelector('[data-cf-add-form], #cf-add-form') || root.querySelector('form');
    var feedback = root.querySelector('[data-cf-feedback]');
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      addBtn.classList.add('is-loading');
      if (feedback) feedback.hidden = true;

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: Number(idField.value),
          quantity: Number(qty.value) || 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          addBtn.classList.remove('is-loading');
          if (!res.ok) throw new Error(res.body.description || 'Could not add to cart');
          if (feedback) { feedback.textContent = 'Added to your cart.'; feedback.className = 'cf-pd__feedback is-ok'; feedback.hidden = false; }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: res.body }));
          if (window.cfRefreshCart) window.cfRefreshCart();
          try {
            var cartDrawerEl = document.querySelector('cart-drawer');
            if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
              cartDrawerEl.renderContents(res.body);
            }
          } catch (drawerErr) {}
        })
        .catch(function (err) {
          addBtn.classList.remove('is-loading');
          if (feedback) { feedback.textContent = err.message; feedback.className = 'cf-pd__feedback is-err'; feedback.hidden = false; }
        });
    });

    markAvailability();

    // --- Guarantee tooltip ------------------------------------------------
    var tipBtn = root.querySelector('[data-cf-tip]');
    var tipBody = root.querySelector('[data-cf-tip-body]');
    if (tipBtn && tipBody) {
      var toggleTip = function (show) {
        var open = show === undefined ? !tipBody.classList.contains('is-open') : show;
        tipBody.classList.toggle('is-open', open);
        tipBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      tipBtn.addEventListener('click', function (e) { e.stopPropagation(); toggleTip(); });
      tipBtn.addEventListener('mouseenter', function () { toggleTip(true); });
      root.addEventListener('mouseleave', function () { toggleTip(false); });
      document.addEventListener('click', function () { toggleTip(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggleTip(false); });
    }

    // --- Gift note --------------------------------------------------------
    var giftToggle = root.querySelector('[data-cf-gift-toggle]');
    var giftNote = root.querySelector('[data-cf-gift-note]');
    var giftArea = root.querySelector('[data-cf-gift-textarea]');
    var giftCount = root.querySelector('[data-cf-gift-count]');
    if (giftToggle && giftNote && giftArea) {
      giftToggle.addEventListener('change', function () {
        giftNote.hidden = !giftToggle.checked;
        // Disabled inputs aren't submitted, so the note only becomes a line-item
        // property when the gift box is actually ticked.
        giftArea.disabled = !giftToggle.checked;
        if (giftToggle.checked) giftArea.focus();
      });
      giftArea.addEventListener('input', function () {
        if (giftCount) giftCount.textContent = giftArea.value.length;
      });
    }

    // --- Size guide modal -------------------------------------------------
    var sgModal = root.querySelector('[data-cf-sizeguide]');
    var sgOpen = root.querySelector('[data-cf-sizeguide-open]');
    if (sgModal && sgOpen) {
      var lastFocus = null;
      var openSg = function () {
        lastFocus = document.activeElement;
        sgModal.hidden = false;
        document.body.style.overflow = 'hidden';
        var closeBtn = sgModal.querySelector('[data-cf-sizeguide-close]');
        if (closeBtn) closeBtn.focus();
      };
      var closeSg = function () {
        sgModal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      };
      sgOpen.addEventListener('click', openSg);
      sgModal.querySelectorAll('[data-cf-sizeguide-close]').forEach(function (el) {
        el.addEventListener('click', closeSg);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !sgModal.hidden) closeSg();
      });
    }

    // --- Related products (lazy) -----------------------------------------
    var rec = root.querySelector('[data-cf-recommendations]');
    if (rec && !rec.querySelector('.cf-pd__related-grid')) {
      fetch(rec.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var block = doc.querySelector('[data-cf-recommendations]');
          if (block && block.innerHTML.trim()) {
            rec.innerHTML = block.innerHTML;
            window.cfRevealRescan && window.cfRevealRescan(rec);
          }
        })
        .catch(function () {});
    }
  }

  function boot() { document.querySelectorAll('[data-cf-product]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-cf-product]');
    if (el) { el.dataset.cfPdInit = ''; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-services"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Shared scroll reveal. Duplicated verbatim in each cf-* section on purpose:
  // you install these files one at a time, and a section shouldn't break
  // because a different one hasn't been added yet. The guard means it
  // initialises exactly once no matter how many sections carry it.
  if (window.cfRevealInit) return;
  window.cfRevealInit = true;

  function observe(scope) {
    var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cf-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cf-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () { observe(); });
  if (document.readyState !== 'loading') observe();
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-shop-by-category"] && !Shopify.designMode) return;
  try {
    
  // --- Shared scroll reveal ---------------------------------------------
  // Duplicated verbatim across sections on purpose: each page must be able to
  // reveal its own content without depending on some other section being
  // present. The window guard means it initialises exactly once per page no
  // matter how many sections carry it.
  (function () {
    if (window.cfRevealInit) return;
    window.cfRevealInit = true;

    // Opt in to the hidden-then-revealed styling only now that we can
    // guarantee something will reveal it.
    document.documentElement.classList.add('cf-reveal-ready');

    function observe(scope) {
      var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('cf-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cf-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    window.cfRevealRescan = function (scope) { observe(scope); };
    document.addEventListener('DOMContentLoaded', function () { observe(); });
    if (document.readyState !== 'loading') observe();
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-why-choose"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Shared reveal: adds .cf-in when an element scrolls into view. Replaces
  // framer-motion's whileInView across every cf-* section. Registered once —
  // guarded so multiple sections importing this don't stack observers.
  if (window.cfRevealInit) return;
  window.cfRevealInit = true;

  function observe(scope) {
    var els = (scope || document).querySelectorAll('.cf-reveal:not(.cf-in)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cf-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cf-in');
        io.unobserve(entry.target); // reveal once; don't re-animate on scroll back
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () { observe(); });
  if (document.readyState !== 'loading') observe();
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
